module.exports = __webpack_public_path__ + "img/icons_39.7d6fc4dc.png";